module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gcrhj"))).then(() => module.bundle.root('gtEzC'));